<template>
  <div>
    <el-main v-loading="loading">
      <!-- 搜索栏 -->
      <div class="search-box">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="标题">
            <el-input v-model="searchForm.title" size="small" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" size="small" placeholder="请选择状态" clearable>
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="已审核" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="search">搜索</el-button>
            <el-button size="small" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <el-table :data="list" border style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="150" align="center"></el-table-column>
        <el-table-column label="封面" width="120" align="center">
          <template slot-scope="scope">
            <el-image 
              style="width: 80px; height: 80px"
              :src="scope.row.picture"
              :preview-src-list="[scope.row.picture]"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="用户" min-width="150" align="center">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center;">
                <img :src="scope.row.avatar" style="width: 30px; height: 30px; border-radius: 50%;margin-right: 10px;">
                {{ scope.row.nickname }}
           </div>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容描述" min-width="200" align="center"></el-table-column>
        <el-table-column label="数据统计" align="center">
          <template slot-scope="scope">
            <div>浏览：{{ scope.row.page_view }}</div>
            <div>点赞：{{ scope.row.like_nums }}</div>
            <div>评论：{{ scope.row.commnet_nums }}</div>
            <div>转发：{{ scope.row.forward_nums }}</div>
            <div>收藏：{{ scope.row.collect_nums }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 0 ? 'warning' : (scope.row.status === 1 ? 'success' : 'danger')">
              {{ scope.row.status === 0 ? '待审核' : (scope.row.status === 1 ? '已通过' : '未通过') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" width="180" align="center">
          <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button 
              type="text" 
              @click="previewVideo(scope.row)"
            >预览</el-button>
            <el-button 
              v-if="scope.row.status === 0 || scope.row.status === 1"
              type="text" 
              @click="showAuditDialog(scope.row)"
            >审核</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <!-- 视频预览弹窗 -->
      <el-dialog
        title="视频预览"
        :visible.sync="dialogVisible"
        width="800px"
        :before-close="handleClose"
      >
        <video
          v-if="currentVideo"
          :src="currentVideo"
          controls
          style="width: 100%"
        ></video>
      </el-dialog>

      <!-- 审核弹窗 -->
      <el-dialog
        title="视频审核"
        :visible.sync="auditDialogVisible"
        width="500px"
      >
        <el-form :model="auditForm" ref="auditForm" :rules="auditRules" label-width="100px">
          <el-form-item label="审核结果" prop="status">
            <el-radio-group v-model="auditForm.status">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="拒绝原因" prop="reject_reason" v-if="auditForm.status === 2">
            <el-input 
              type="textarea" 
              v-model="auditForm.reject_reason" 
              placeholder="请输入拒绝原因"
              :rows="4"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="auditDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAudit">确定</el-button>
        </div>
      </el-dialog>
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'VideoList',
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        title: '',
        status: ''
      },
      dialogVisible: false,
      currentVideo: '',
      auditDialogVisible: false,
      auditForm: {
        id: null,
        status: 1,
        reject_reason: ''
      },
      auditRules: {
        status: [
          { required: true, message: '请选择审核结果', trigger: 'change' }
        ],
        reject_reason: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' }
        ]
      }
    };
  },
  filters: {
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString()
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.loading = true   
      try {
        const res = await this.$axios.post('/Gateway/Video/list', {
            page: this.page,
            rows: this.pageSize,
            ...this.searchForm
        })
        if (res.code === 0) {
          this.list = res.result.list
          this.total = res.result.total_number
        }
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },

    // 搜索
    search() {
      this.page = 1
      this.getList()
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        title: '',
        status: ''
      }
      this.search()
    },

    // 预览视频
    previewVideo(row) {
      this.currentVideo = row.video
      this.dialogVisible = true
    },

    // 关闭预览弹窗
    handleClose() {
      this.currentVideo = ''
      this.dialogVisible = false
    },

    // 显示审核弹窗
    showAuditDialog(row) {
      this.auditForm = {
        id: row.id,
        status: row.status === 0 ? 1 : row.status,
        reject_reason: ''
      }
      this.auditDialogVisible = true
    },

    // 提交审核
    submitAudit() {
      this.$refs.auditForm.validate(async (valid) => {
        if (valid) {
          try {
            await this.$axios.post('/Gateway/Video/editStatus', this.auditForm)
            this.$message.success('审核操作成功')
            this.auditDialogVisible = false
            this.getList()
          } catch (error) {
            console.error(error)
          }
        }
      })
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    }
  }
};
</script>

<style lang="less" scoped>
.el-main {
  background: #fff;
  padding: 20px;
}

.search-box {
  margin-bottom: 20px;
}

.pagination-box {
  margin-top: 20px;
  text-align: right;
}

.el-table {
  .el-image {
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>

